<template>
  <el-form
    :model="part"
    ref="partForm"
    :rules="rules"
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <h4 class="form-title">Part Information</h4>
    <el-row :gutter="15">
      <el-col :sm="8" :xs="24">
        <el-form-item label="Part No." prop="part_no">
          <el-input v-model="part.part_no"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="16">
        <el-form-item label="Description" prop="description">
          <el-input v-model="part.description"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :sm="16">
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="Location" prop="location">
              <!-- <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                v-model="part.location"
              > -->
              <el-input v-model="part.location"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Re-Order Point" prop="re_order_pt">
              <el-input-number
                :controls="false"
                v-model.number="part.re_order_pt"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col class="mb-2">
            <h4>Stock Quantity</h4>
            <el-table
              :data="part.stocks"
              :summary-method="getSummaries"
              show-summary
            >
              <el-table-column
                label="Batch No."
                prop="batch_no"
              ></el-table-column>
              <el-table-column
                label="Supplier"
                prop="supplier"
              ></el-table-column>
              <el-table-column label="Final Price (AED)" prop="final_price_aed">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.final_price_aed | currency("AED ", 2)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Final Price (USD)" prop="final_price_aed">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.final_price_usd | currency("$ ", 2)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Quantity" prop="quantity">
                <template slot-scope="scope">
                  <span>{{ scope.row.quantity | number("0,0") }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!--  <p class="text-right">
              <label>{{ totalQuantity | number("0,0") }}</label>
            </p> -->
          </el-col>
        </el-row>
      </el-col>
      <el-col :sm="8">
        <el-form-item label="Image" prop="image_path">
          <img
            class="img-responsive img-bordered"
            v-if="imageUrl"
            :src="imageUrl"
            alt="Part Image"
          />
          <el-upload
            :action="api.href"
            :headers="api.headers"
            accept="image/*"
            :data="{ q: 'parts' }"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            v-if="user.isRole([1, 2])"
          >
            <el-button size="small" type="primary">Upload</el-button>
          </el-upload>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="d-flex">
      <el-button
        v-if="user.isRole([1, 2])"
        size="small"
        type="primary"
        @click="submit"
        >Save</el-button
      >
      <router-link
        v-if="part.id && user.isRole([1, 2])"
        class="el-button el-button--primary el-button--small"
        :to="{ name: 'request_info', query: { part_id: part.id } }"
        ><i class="el-icon-position"></i> Request for Stock</router-link
      >
      <router-link
        v-if="part.id"
        class="el-button el-button--primary el-button--small"
        :to="{ name: 'print_partbarcode', params: { id: part.id } }"
      >
        Print Barcode</router-link
      >
      <el-button size="small" @click="cancel">Cancel</el-button>
    </div>
  </el-form>
</template>

<script>
import api from "@/api";
import Part from "@/models/Part";
export default {
  name: "part_info",
  computed: {
    // suppliers() {
    //   return this.$store.getters["supplier/glossary"];
    // }
    user() {
      return this.$store.getters["auth/user"];
    },
    api() {
      return {
        headers: {
          // "Content-Type": "multipart/form-data",
          Authorization: `${this.$store.getters["auth/token"].token_type} ${this.$store.getters["auth/token"].access_token}`,
          "X-Requested-With": "XMLHttpRequest"
        },
        href: new URL("/api/v1/inventory/fileupload/", api.baseUrl).href
      };
    },
    totalQuantity() {
      if (this.part.stocks.length == 0) return 0;
      let initialValue = 0;
      var sum = this.part.stocks.reduce(
        (accumulator, currentValue) => accumulator + currentValue.quantity,
        initialValue
      );
      return sum;
    }
  },
  data() {
    return {
      rules: Part.rules(),
      part: new Part(),
      isLoading: false,
      isDeprecated: false,
      imageUrl: ""
    };
  },
  mounted() {
    this.isLoading = true;
    if (this.$route.params && this.$route.params.id) {
      Part.fetch(this.$route.params.id).then(resp => {
        this.part = new Part(resp);
        this.isLoading = false;
        this.imageUrl = "data:image;base64, " + resp.image;
      });
    } else {
      this.isLoading = false;
    }
    // this.$store.dispatch("supplier/getGlossary").then(() => {
    //   if (this.$route.params && this.$route.params.id) {
    //     Part.fetch(this.$route.params.id).then(resp => {
    //       this.part = new Part(resp);
    //       this.isLoading = false;
    //       var found = this.suppliers.find(o => {
    //         return o.id == this.part.supplier_id;
    //       });
    //       if (!found) {
    //         this.part.supplier_id = "";
    //         this.isDeprecated = true;
    //       }
    //     });
    //   } else {
    //     this.isLoading = false;
    //   }
    // });
  },
  methods: {
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index == 0) {
          sums[index] = "";
          return;
        } else if (index == 2) {
          sums[index] = "Total Quantity";
        } else if (index == 4) {
          sums[index] = this.$options.filters.number(this.totalQuantity, "0,0");
        }
      });

      return sums;
    },
    beforeUpload() {},
    handleUploadSuccess(res, file) {
      if (
        res.hasOwnProperty("data") &&
        res.data.hasOwnProperty("code") &&
        res.data.code == 200
      ) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.part.image_path = res.data.msg;
      } else {
        this.$notify({
          type: "error",
          message: res.data.msg,
          position: "bottom-right"
        });
      }
    },
    cancel() {
      return this.$router.push({
        name: "parts"
      });
    },
    submit() {
      this.$confirm("Are you sure you want to save this part information?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.$refs["partForm"].validate(valid => {
            if (!valid) {
              return false;
            }
            if (this.part.id) {
              this.isLoading = true;
              Part.put(this.part).then(resp => {
                this.isLoading = false;
                if (resp.code == 200) {
                  this.$router.push({
                    name: "parts"
                  });
                  this.$notify({
                    type: "success",
                    message: "Part information saved.",
                    position: "bottom-right"
                  });
                }
              });
            } else {
              this.isLoading = true;
              Part.create(this.part).then(resp => {
                if (resp.code == 200) {
                  this.$router.push({
                    name: "parts"
                  });
                  this.$notify({
                    type: "success",
                    message: "Part information saved.",
                    position: "bottom-right"
                  });
                }
                this.isLoading = false;
              });
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style type="text/css" scoped="true">
.img-bordered {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px;
}
</style>
